import { useCallback } from 'react';
import speak from '@shared/utils/speak';
import { VOICED_TRAFFIC_SITUATIONS_PRIORITY } from '@shared/constants';
import useManuallyTriggeredAudio from '@shared/hooks/useManuallyTriggeredAudio';
import { TrafficSituation } from '../models/trafficSituation';
import { DeepReadonly } from 'ts-essentials';

export default function useVoicedTrafficSituations(
  trafficSituations: DeepReadonly<TrafficSituation[]>,
) {
  const voiceTrafficSituations = useCallback(async () => {
    if (trafficSituations.length === 0) {
      return;
    }

    await speak('Trafikinformation.');
    for (const trafficSituation of trafficSituations) {
      const trafficSituationSpeechText = `${
        trafficSituation.title ? trafficSituation.title + ' ' : ''
      }${trafficSituation.description ? trafficSituation.description : ''}`;
      await speak(trafficSituationSpeechText);
    }
  }, [trafficSituations]);

  useManuallyTriggeredAudio(
    VOICED_TRAFFIC_SITUATIONS_PRIORITY,
    voiceTrafficSituations,
  );
}
